import styled from "styled-components";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import React from "react";
import theme from "../../theme/feedback";

export const Panel = styled.div`
  background: ${theme.color.surface};
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.lg};
  box-shadow: 0px 2px 8px rgba(21, 34, 50, 0.06);
  padding: ${theme.spacing.lg};
  margin-bottom: ${theme.spacing.lg};
`;

export const PanelTitle = styled.h3`
  font-family: ${theme.font.family};
  font-size: ${theme.font.sizeLg};
  font-weight: ${theme.font.weightSemibold};
  color: ${theme.color.text};
  margin: 0 0 ${theme.spacing.md} 0;
  padding: 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: ${theme.font.family};
`;

export const Th = styled.th`
  text-align: ${(props) => props.align || "left"};
  font-size: ${theme.font.sizeSm};
  font-weight: ${theme.font.weightSemibold};
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${theme.color.textMuted};
  padding: 0 ${theme.spacing.sm} ${theme.spacing.sm} ${theme.spacing.sm};
  border-bottom: 2px solid ${theme.color.border};
  white-space: nowrap;

  span[role="button"] {
    cursor: pointer;
    user-select: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  &:hover span[role="button"] {
    color: ${theme.color.primary};
  }
`;

export const Td = styled.td`
  text-align: ${(props) => props.align || "left"};
  font-size: ${theme.font.sizeMd};
  color: ${theme.color.text};
  padding: ${theme.spacing.sm};
  border-bottom: 1px solid ${theme.color.border};
`;

export const Bodyrow = styled.tr`
  transition: background 0.15s ease;
  &:hover {
    background: ${theme.color.surfaceAlt};
  }
  &:last-child td {
    border-bottom: none;
  }
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: ${theme.color.surfaceAlt};
  color: ${theme.color.primary};
  font-weight: ${theme.font.weightSemibold};
  font-size: ${theme.font.sizeSm};
`;

export const EmptyState = styled.div`
  font-family: ${theme.font.family};
  font-size: ${theme.font.sizeMd};
  color: ${theme.color.textMuted};
  text-align: center;
  padding: ${theme.spacing.xl} 0;
`;

export const Scroll = styled.div`
  max-height: 210px;
  overflow-y: auto;

  thead th {
    position: sticky;
    top: 0;
    background: ${theme.color.surface};
    z-index: 1;
  }
`;

// Sortable header label. `sort` is -1 | 0 | 1; clicking toggles direction.
export const SortLabel = ({ label, sort, onSort, align }) => (
  <Th align={align}>
    <span
      role="button"
      onClick={() => onSort({ sort: sort === 1 ? -1 : 1 })}
    >
      {label}
      {sort === 1 && <ArrowUpOutlined />}
      {sort === -1 && <ArrowDownOutlined />}
    </span>
  </Th>
);
